import { generatePath } from '@/services/router/generate-path';
import { getWorkspaceIdFromCurrentUrl } from '@/context/current-workspace';
import { useServicesQuery } from '@/services/api';
import { useActiveHealthTab } from '../hooks';
import { TotalsPanel } from './totals-panel';
import { WORKSPACE_HEALTH_REFETCH_INTERVAL } from '@/features/workspace-health';

export function EventsPanel() {
  const workspaceId = getWorkspaceIdFromCurrentUrl() ?? 0;
  const { activeTab } = useActiveHealthTab();

  const totalsQuery = useServicesQuery(
    'getEventNamesTotals',
    { params: { environment_id: workspaceId } },
    { refetchInterval: WORKSPACE_HEALTH_REFETCH_INTERVAL, enabled: workspaceId > 0 && activeTab === 'data' },
  );

  return (
    <TotalsPanel
      title="Events"
      isLoading={totalsQuery.isLoading}
      totals={totalsQuery.data?.totals}
      viewAllHref={generatePath('/workspaces/:workspaceId/journeys/data-index/:type', { workspaceId, type: 'events' })}
      viewAllDestination="events"
    />
  );
}
